import { render, staticRenderFns } from "./reporte-contactos.vue?vue&type=template&id=422d5c2a&scoped=true"
import script from "./reporte-contactos.vue?vue&type=script&lang=js"
export * from "./reporte-contactos.vue?vue&type=script&lang=js"
import style0 from "./reporte-contactos.vue?vue&type=style&index=0&id=422d5c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422d5c2a",
  null
  
)

export default component.exports